import { render, staticRenderFns } from "./TelInputOld.vue?vue&type=template&id=95b4de26"
import script from "./TelInputOld.vue?vue&type=script&lang=js"
export * from "./TelInputOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports